import Service, { service } from '@ember/service';
import numberSort from 'scaleflow/utils/numberSort';

export default class DropdownService extends Service {
  @service store;
  @service teams;
  @service users;
  @service roadmap;
  @service betaToggle;
  @service initiatives;

  get teamsList() {
    return this.teams.teamOptions;
  }

  get productManagersList() {
    return this.users.getUsersSync().map((item) => ({
      abbreviation: item.abbreviation,
      color: item.color,
      label: item.name,
      value: item.id,
    }));
  }

  get submittersList() {
    return this.users.getUsersSync().map((item) => ({
      abbreviation: item.abbreviation,
      color: item.color,
      label: item.name,
      value: item.id,
    }));
  }

  get initiativesList() {
    return this.initiatives.getInitiativesSync().map((item) => ({
      label: item.title,
      value: item.id,
    }));
  }

  get groupsList() {
    return this.store.peekAll('group').map((item) => ({
      label: item.title,
      value: item.id,
    }));
  }

  get roadmapsList() {
    return this.roadmap.roadmaps_sorted_by_start_date.map((item) => ({
      value: item.id,
      label: item.title,
    }));
  }

  get sourcesList() {
    let options = [...this.betaToggle.sourceOptions].sort((a, b) =>
      numberSort(a.tableOrder, b.tableOrder, 'asc'),
    );
    return options;
  }

  get themesList() {
    return this.store.peekAll('theme').map((item) => ({
      color: item.color,
      label: item.title,
      value: item.id,
    }));
  }

  get goalsList() {
    return this.store.peekAll('goal').map((item) => ({
      label: item.title,
      value: item.id,
    }));
  }

  get areasList() {
    return this.store.peekAll('area').map((item) => ({
      label: item.name,
      value: item.id,
    }));
  }

  get departmentsList() {
    return this.store.peekAll('department').map((item) => ({
      label: item.name,
      value: item.id,
    }));
  }

  get customersList() {
    return this.store.peekAll('customer').map((item) => ({
      label: item.name,
      value: item.id,
    }));
  }

  get statusesList() {
    return [...this.betaToggle.statusOptions].sort((a, b) =>
      numberSort(a.tableOrder, b.tableOrder, 'asc'),
    );
  }

  get ideaStatusesList() {
    return [...this.betaToggle.ideaStatusOptions].sort((a, b) =>
      numberSort(a.tableOrder, b.tableOrder, 'asc'),
    );
  }

  get updatesList() {
    return this.betaToggle.healthOptions;
  }

  get columnsList() {
    return this.betaToggle.columnOptions.map((item) => ({
      ...item,
      label: item.label,
      value: item.label,
      show: item.show,
    }));
  }
}
